import { useEffect, useState } from 'react' 
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import EventFeed from './EventFeed'
import CreateEventModal from './CreateEventModal'
import { 
    setViewEventModal, 
    hideEventModal,
    setViewAddCalendarItemModal, 
} from '../../features/events/eventSlice' 
import CreateButton from 'components/buttons/CreateButton'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import Calendar from './calendar/Calendar'
import { Modal } from '@mui/material'
import { ComponentPageWrapper } from 'pages/pages.styled'
import { MobilePageTitle } from 'components/main.styled'

import toast, { Toaster } from 'react-hot-toast';
import CreateCalendarItem from './calendar/CreateCalendarItem' 
import SectionHelp from 'components/help/SectionHelp'
import { useTranslation } from 'react-i18next'

export default function Events() {
  const { t: translate } = useTranslation()
 
    const dispatch = useDispatch() 
    const { user, admin } = useSelector((state) => state.auth)
    const {  isError, message  } = useSelector((state) => state.profile)
    const { profileChurch } = useSelector((state) => state.profileChurch)   
    const [ eventView , setEventView ] = useState( localStorage.getItem('eventView') ?? 'items'  ) // ['items', 'calendar', 'past']
      const { 
        viewEventModal, viewEventModalEdit, eventEditData,  eventEditIndex, createCalendarItemStatus, viewAddCalendarItemModal
    } = useSelector((state) => state.events)

    useEffect(() => {
        if(isError){toast.error(message)} 
    }, [])
 
    useEffect(() => {

        if(createCalendarItemStatus === "SUCCESS"){
            toast.success(translate('events:calendar.created'))
        }

    }, [createCalendarItemStatus])



    const handleCreateEvent = () => {
        dispatch(setViewEventModal())
    }

    const handleViewCalendar = () => {
        if(eventView === 'items'){
            setEventView('calendar')
            localStorage.setItem('eventView', 'calendar')
        }else{
            setEventView('items')
            localStorage.setItem('eventView', 'items')
        }
    }

        const handleCreateCalendarItem = () => {
            dispatch(setViewAddCalendarItemModal(true))
    
        }
    
    return (
        
        <ComponentPageWrapper>
            <Toaster />
            <MobilePageTitle>
                {translate("web:general.events")}
            </MobilePageTitle>

            <EventsTop>


                <CreateButton 
                    customIcon={eventView === 'items' ? <CalendarMonthIcon/> : <CalendarViewMonthIcon/>}
                    handler={handleViewCalendar} 
                    buttonText={eventView === 'items' ? translate("web:general.viewCalendar") : translate("web:general.viewItems")}
                    />

                {(user.isOrganization || admin[profileChurch._id]) && (
                    <AdminActions>
                        <CreateButton 
                            handler={handleCreateEvent}
                            buttonText={translate('events:actions.new')}
                            />     
                        <CreateButton
                            handler={handleCreateCalendarItem}
                            buttonText={translate('events:create.calendar')}
                            />
                        <SectionHelp
                            title={translate('events:help.title')}
                            intro={translate('events:help.intro')}
                            tooltip={translate('events:help.tooltip')}
                            options={[
                                {
                                    title: translate('events:help.calendarTitle'),
                                    description: translate('events:help.calendarDescription'),
                                    bestFor: translate('events:help.calendarBestFor'),
                                    features: [translate('events:help.calendarFeature1'), translate('events:help.calendarFeature2'), translate('events:help.calendarFeature3')],
                                },
                                {
                                    title: translate('events:help.eventTitle'),
                                    description: translate('events:help.eventDescription'),
                                    bestFor: translate('events:help.eventBestFor'),
                                    features: [translate('events:help.eventFeature1'), translate('events:help.eventFeature2'), translate('events:help.eventFeature3'), translate('events:help.eventFeature4')],
                                },
                            ]}
                            footer={translate('events:help.footer')}
                            />
                    </AdminActions>

                ) }
                        
            </EventsTop>
            
            {
                eventView === 'items' ? (
                    <EventFeed/>
                ) : (
                    <Calendar />
                )
            }
            
            <Modal
                open={viewEventModalEdit}
                style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                onClose={() => dispatch(hideEventModal())}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                <div
                    style={{ 
                        width: '100%',
                        height: '100%',
                        maxHeight: '80vh', 
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',  
                    }}  
                    >
                <CreateEventModal
                    isEditing={true}
                    data={eventEditData}
                    index={eventEditIndex}
                    />
                </div>
            </Modal>


            <Modal  
                open={viewEventModal}
                style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                onClose={() => dispatch(hideEventModal())}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                <div
                    style={{ 
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center', 
                        padding: '10px'
                    }}  
                    >
                       <CreateEventModal /> 
                    </div>
                    
            </Modal> 
            <Modal
                open={viewAddCalendarItemModal}
                onClose={() => {
                    dispatch(setViewAddCalendarItemModal(false))
                }}
                style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                <CreateCalendarItem /> 
            </Modal> 
        </ComponentPageWrapper> 
    )
}


const EventsTop = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;  
    padding: 10px;

    @media (max-width: 768px) { 
        width: 100%;
        margin-bottom: 0px;
        padding: 10px; 
        align-items: center;
        justify-content: flex-start;
    }
` 
const AdminActions = styled.div`
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;

    @media (max-width: 768px) {
        flex-wrap: wrap;
        justify-content: flex-start;
    }
`
